import React from 'react';
import styled from 'styled-components';
import { automationIds } from '../../constants/automationIds';
const SelectOptionContainer = styled.div `
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
`;
const OptionNameSpan = styled.span `
  width: 70%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const DetailedSelectOption = ({ name, details }) => (<SelectOptionContainer>
    <OptionNameSpan data-automation-id={automationIds.DATA_ENTRY.SHARED.SELECT.OPTION_VALUE}>
      {name}
    </OptionNameSpan>
    {details}
  </SelectOptionContainer>);
export default DetailedSelectOption;
